import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Table, Button, Form, Alert } from 'react-bootstrap';
import { FaSearch } from 'react-icons/fa';
import axios from 'axios';
import dayjs from 'dayjs';
import { API_BASE_URL } from '../api/axiosConfig';
const formatLocation = (rack, floor, cell) => {
    const parts = [rack, floor, cell]
        .map((value) => String(value !== null && value !== void 0 ? value : '').trim())
        .filter(Boolean);
    return parts.length === 3 ? `(${parts.join('-')})` : '';
};
const PeriodSalesStatus = () => {
    const [orders, setOrders] = useState([]);
    const [aggregatedProducts, setAggregatedProducts] = useState([]);
    const [filteredProducts, setFilteredProducts] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);
    const [loading, setLoading] = useState(false);
    // 검색 필터
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    // 기간 검색 관련 상태
    const [periodType, setPeriodType] = useState('order_date');
    const [quickPeriod, setQuickPeriod] = useState('');
    useEffect(() => {
        fetchOrders();
    }, []);
    useEffect(() => {
        filterProducts();
    }, [aggregatedProducts, searchTerm, startDate, endDate]);
    const fetchOrders = async () => {
        setLoading(true);
        setError(null);
        try {
            const response = await axios.get(`${API_BASE_URL}/api/orders/seq/period`, {
                params: startDate && endDate ? { startDate, endDate } : undefined
            });
            console.log('API Response:', response.data); // 디버깅을 위한 로그
            // API 응답이 data 속성을 가지고 있는지 확인
            const ordersData = response.data.orders || [];
            if (!Array.isArray(ordersData)) {
                throw new Error('API 응답이 올바른 형식이 아닙니다.');
            }
            setOrders(ordersData);
            // 상품별 주문 합계 계산
            const aggregated = ordersData.reduce((acc, item) => {
                if (!acc[item.product_code]) {
                    acc[item.product_code] = {
                        productCode: item.product_code,
                        productName: item.product_name,
                        totalQuantity: 0,
                        orders: []
                    };
                }
                acc[item.product_code].totalQuantity += item.quantity;
                acc[item.product_code].orders.push({
                    orderNumber: item.order_number,
                    shipComp: item.ship_comp || '',
                    recipientName: item.recipient_name || '',
                    quantity: item.quantity,
                    orderDate: item.order_date,
                    status: item.status,
                    location: formatLocation(item.A, item.B, item.C)
                });
                return acc;
            }, {});
            setAggregatedProducts(Object.values(aggregated));
        }
        catch (err) {
            console.error('Error fetching orders:', err);
            setError('주문 데이터를 불러오는 중 오류가 발생했습니다.');
        }
        finally {
            setLoading(false);
        }
    };
    const filterProducts = () => {
        let filtered = [...aggregatedProducts];
        if (searchTerm) {
            filtered = filtered.filter(product => product.productCode.toLowerCase().includes(searchTerm.toLowerCase()) ||
                product.productName.toLowerCase().includes(searchTerm.toLowerCase()));
        }
        if (startDate) {
            filtered = filtered.filter(product => product.orders.some(order => order.orderDate >= startDate));
        }
        if (endDate) {
            filtered = filtered.filter(product => product.orders.some(order => order.orderDate <= endDate));
        }
        setFilteredProducts(filtered);
    };
    const handleSearch = async (e) => {
        e.preventDefault();
        await fetchOrders();
        filterProducts();
    };
    // 빠른 기간 선택 핸들러
    const handleQuickPeriod = (type) => {
        setQuickPeriod(type);
        let start = '';
        let end = '';
        const today = dayjs();
        if (type === 'today') {
            start = today.format('YYYY-MM-DD');
            end = today.format('YYYY-MM-DD');
        }
        else if (type === '1week') {
            start = today.subtract(6, 'day').format('YYYY-MM-DD');
            end = today.format('YYYY-MM-DD');
        }
        else if (type === '1month') {
            start = today.subtract(1, 'month').format('YYYY-MM-DD');
            end = today.format('YYYY-MM-DD');
        }
        else if (type === '6month') {
            start = today.subtract(6, 'month').format('YYYY-MM-DD');
            end = today.format('YYYY-MM-DD');
        }
        setStartDate(start);
        setEndDate(end);
    };
    return (_jsxs(Container, { fluid: true, children: [_jsx(Row, { className: "mb-4", children: _jsx(Col, { children: _jsx("h2", { children: "\uAE30\uAC04\uBCC4 \uD310\uB9E4\uD604\uD669" }) }) }), error && (_jsx(Alert, { variant: "danger", onClose: () => setError(null), dismissible: true, children: error })), success && (_jsx(Alert, { variant: "success", onClose: () => setSuccess(null), dismissible: true, children: success })), _jsx(Card, { className: "mb-4", children: _jsx(Card.Body, { children: _jsx(Form, { onSubmit: handleSearch, children: _jsx(Row, { className: "align-items-center", children: _jsx(Col, { md: 12, className: "mb-2", children: _jsxs("div", { className: "d-flex align-items-center flex-wrap", children: [_jsx("span", { className: "fw-bold me-2", children: "\uAE30\uAC04:" }), _jsxs(Form.Select, { value: periodType, onChange: e => setPeriodType(e.target.value), style: { width: 130, display: 'inline-block', marginRight: 8 }, children: [_jsx("option", { value: "order_date", children: "\uB4F1\uB85D\uC77C\uC790" }), _jsx("option", { value: "order_date", children: "\uC8FC\uBB38\uC77C\uC790" })] }), _jsx(Button, { variant: quickPeriod === 'today' ? 'dark' : 'outline-secondary', size: "sm", className: "me-1", onClick: () => handleQuickPeriod('today'), children: "\uC624\uB298" }), _jsx(Button, { variant: quickPeriod === '1week' ? 'dark' : 'outline-secondary', size: "sm", className: "me-1", onClick: () => handleQuickPeriod('1week'), children: "1\uC8FC\uC77C" }), _jsx(Button, { variant: quickPeriod === '1month' ? 'dark' : 'outline-secondary', size: "sm", className: "me-1", onClick: () => handleQuickPeriod('1month'), children: "1\uAC1C\uC6D4" }), _jsx(Button, { variant: quickPeriod === '6month' ? 'dark' : 'outline-secondary', size: "sm", className: "me-2", onClick: () => handleQuickPeriod('6month'), children: "6\uAC1C\uC6D4" }), _jsx(Form.Control, { type: "date", value: startDate, onChange: e => { setStartDate(e.target.value); setQuickPeriod(''); }, style: { width: 150, display: 'inline-block', marginRight: 8 } }), _jsx("span", { className: "mx-1", children: "~" }), _jsx(Form.Control, { type: "date", value: endDate, onChange: e => { setEndDate(e.target.value); setQuickPeriod(''); }, style: { width: 150, display: 'inline-block', marginRight: 8 } }), _jsxs("div", { className: "d-flex justify-content-end align-items-center ms-auto", style: { minWidth: 420 }, children: [_jsx(Form.Label, { className: "mb-0 me-2", style: { minWidth: 100, fontWeight: 'bold', fontSize: '1rem', height: 40, display: 'flex', alignItems: 'center' }, children: "\uC0C1\uD488\uCF54\uB4DC/\uBA85" }), _jsx(Form.Control, { type: "text", placeholder: "\uC0C1\uD488\uCF54\uB4DC \uB610\uB294 \uC0C1\uD488\uBA85", value: searchTerm, onChange: (e) => setSearchTerm(e.target.value), style: { borderTopRightRadius: 0, borderBottomRightRadius: 0, height: 40, fontSize: '1rem' } }), _jsxs(Button, { variant: "primary", type: "submit", style: { borderTopLeftRadius: 0, borderBottomLeftRadius: 0, marginLeft: '-1px', minWidth: 120, fontWeight: 'bold', background: '#7b8cff', border: 'none', height: 40, fontSize: '1rem', display: 'flex', alignItems: 'center', justifyContent: 'center' }, children: [_jsx(FaSearch, { className: "me-1" }), "\uAC80\uC0C9"] })] })] }) }) }) }) }) }), _jsx(Card, { children: _jsx(Card.Body, { children: loading ? (_jsx("div", { className: "text-center py-4", children: _jsx("div", { className: "spinner-border text-primary", role: "status", children: _jsx("span", { className: "visually-hidden", children: "Loading..." }) }) })) : filteredProducts.length === 0 ? (_jsx("div", { className: "text-center py-4", children: "\uB370\uC774\uD130\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4." })) : (_jsxs(Table, { responsive: true, hover: true, children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", { style: { width: '15%' }, children: "\uC0C1\uD488\uCF54\uB4DC" }), _jsx("th", { style: { width: '25%' }, children: "\uC0C1\uD488\uBA85" }), _jsx("th", { style: { width: '10%' }, children: "\uCD1D\uD310\uB9E4\uC218\uB7C9" }), _jsx("th", { style: { width: '50%' }, children: "\uC8FC\uBB38\uC815\uBCF4" })] }) }), _jsx("tbody", { children: filteredProducts.map((product) => (_jsxs("tr", { children: [_jsx("td", { children: product.productCode }), _jsx("td", { children: product.productName }), _jsx("td", { className: "text-end", children: product.totalQuantity.toLocaleString() }), _jsx("td", { children: _jsx("div", { style: {
                                                    maxHeight: '150px',
                                                    overflowY: 'auto',
                                                    padding: '8px',
                                                    backgroundColor: '#f8f9fa',
                                                    borderRadius: '4px',
                                                    border: '1px solid #dee2e6'
                                                }, children: product.orders.map((order, index) => (_jsxs("div", { style: {
                                                        padding: '4px 8px',
                                                        marginBottom: '4px',
                                                        backgroundColor: '#fff',
                                                        borderRadius: '4px',
                                                        border: '1px solid #e9ecef',
                                                        fontSize: '0.9rem'
                                                    }, children: [_jsxs("span", { style: { fontWeight: 'bold' }, children: [order.shipComp ? `${order.shipComp} ` : '', order.shipComp && order.shipComp.toUpperCase() !== 'COUPANG' && order.recipientName
                                                                    ? `${order.recipientName} `
                                                                    : '', order.orderNumber, order.location ? ` ${order.location}` : ''] }), _jsx("span", { style: { marginLeft: '8px' }, children: order.orderDate }), _jsxs("span", { style: { float: 'right' }, children: [order.quantity.toLocaleString(), "\uAC1C", _jsx("span", { style: {
                                                                        marginLeft: '8px',
                                                                        color: order.status === '완료' ? '#28a745' :
                                                                            order.status === '진행중' ? '#ffc107' : '#dc3545'
                                                                    }, children: order.status })] })] }, index))) }) })] }, product.productCode))) })] })) }) })] }));
};
export default PeriodSalesStatus;
